(function () {
  'use strict';

  const styleTag = document.createElement('style');
  styleTag.textContent = `
    @keyframes cart-fly-bounce {
      0%   { transform: scale(1); }
      28%  { transform: scale(1.3); }
      55%  { transform: scale(0.9); }
      78%  { transform: scale(1.12); }
      100% { transform: scale(1); }
    }
    #cart-icon-bubble.cart-fly--bounce {
      animation: cart-fly-bounce 0.45s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform-origin: center;
    }
    .cart-fly-ghost { will-change: transform, opacity; }
  `;
  document.head.appendChild(styleTag);

  const DURATION = 700;

  let pendingOrigin = null;

  function isInViewport(r) {
    const vh = window.innerHeight;
    // Accept if at least 40% of the element's height is visible
    return r.width > 0 && r.height > 0
      && r.bottom > r.height * 0.4
      && r.top < vh - r.height * 0.4;
  }

  function captureOrigin(submitBtn) {
    // Prefer the visible product image
    const wrapper = document.querySelector('.product__media-wrapper');
    if (wrapper) {
      const img =
        wrapper.querySelector('.product__media:not([hidden]) img') ||
        wrapper.querySelector('.product__media--image img') ||
        wrapper.querySelector('img[srcset], img[src]');

      if (img) {
        const r = img.getBoundingClientRect();
        if (isInViewport(r)) {
          return {
            x: r.left + r.width / 2,
            y: r.top + r.height / 2,
            src: img.currentSrc || img.src,
          };
        }
      }
    }

    // Fallback: the submit button — always on-screen when the user taps it
    if (submitBtn) {
      const r = submitBtn.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) {
        return {
          x: r.left + r.width / 2,
          y: r.top + r.height / 2,
          src: null, // no image; ghost will be a copper disc
        };
      }
    }

    return null;
  }

  function getCartAnchor() {
    const el = document.getElementById('cart-icon-bubble');
    if (!el) return null;
    const r = el.getBoundingClientRect();
    return { el, cx: r.left + r.width / 2, cy: r.top + r.height / 2 };
  }

  function launchGhost(origin, fallbackSrc) {
    const anchor = getCartAnchor();
    if (!anchor) return;

    const src = origin.src || fallbackSrc;
    // Smaller ghost on mobile so it doesn't dominate the narrow screen
    const ghostSize = window.innerWidth < 750 ? 42 : 62;

    const ghost = document.createElement('div');
    ghost.className = 'cart-fly-ghost';
    Object.assign(ghost.style, {
      position: 'fixed',
      zIndex: '99999',
      width: ghostSize + 'px',
      height: ghostSize + 'px',
      left: origin.x - ghostSize / 2 + 'px',
      top: origin.y - ghostSize / 2 + 'px',
      borderRadius: '50%',
      overflow: 'hidden',
      pointerEvents: 'none',
      boxShadow: '0 6px 20px rgba(0,0,0,0.22)',
      border: '2px solid rgba(255,255,255,0.8)',
    });

    if (src) {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      Object.assign(img.style, {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      });
      ghost.appendChild(img);
    } else {
      ghost.style.background = '#B87333'; // copper brand colour
    }

    document.body.appendChild(ghost);

    const dx = anchor.cx - origin.x;
    const dy = anchor.cy - origin.y;
    // Arc bows the path upward; keep it proportional but bounded
    const arc = Math.min(Math.max(Math.abs(dy) * 0.45, 40), 110);

    const anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        {
          offset: 0.42,
          transform: `translate(${dx * 0.42}px,${dy * 0.42 - arc}px) scale(0.7)`,
          opacity: 1,
        },
        {
          transform: `translate(${dx}px,${dy}px) scale(0.12)`,
          opacity: 0.35,
        },
      ],
      { duration: DURATION, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', fill: 'forwards' }
    );

    anim.onfinish = () => {
      ghost.remove();
      pulseCartIcon(anchor.el);
    };
  }

  function pulseCartIcon(el) {
    el.classList.remove('cart-fly--bounce');
    void el.offsetWidth; // force reflow to restart animation
    el.classList.add('cart-fly--bounce');
    el.addEventListener('animationend', () => el.classList.remove('cart-fly--bounce'), { once: true });
  }

  // Capture origin at the moment the form is submitted (capture phase = before product-form.js)
  document.addEventListener(
    'submit',
    function (evt) {
      const form = evt.target;
      if (!form || !form.closest('product-form')) return;
      const btn = form.querySelector('[type="submit"]');
      pendingOrigin = captureOrigin(btn);
    },
    true
  );

  function wireSubscription() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(wireSubscription, 80);
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;

      const origin = pendingOrigin;
      pendingOrigin = null;
      if (!origin) return;

      const fallback =
        data.cartData && data.cartData.featured_image
          ? data.cartData.featured_image.url
          : null;

      requestAnimationFrame(() => launchGhost(origin, fallback));
    });
  }

  wireSubscription();
})();
